import React, { useState } from "react";
import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();
import Link from "next/link";

import {
  composeFormValidators,
  isRequired,
  isEmail,
  hasMaxLength,
} from "@lib/validations";

import InputText from "@components/Form/InputText";
import Button from "@components/Button";
import { userLogin } from "@store/user/actions";
import { addModal, removeModal } from "@store/app/actions";

const LoginForm = (props) => {
  const [smsData, setSmsData] = useState(null);

  const loginAction = async (values) => {
    const res = await props.userLogin(
      values,
      props.redirect || null,
      true,
      props.location
    );

    if (res && !res.token && res.data) {
      setSmsData(res.data);
    }
  };

  const postSmsAction = (values) =>
    props.userLogin(
      {
        sent_code: values.sent_code,
        telephone: smsData.telephone,
        id: smsData.id,
        customer_id: smsData.customer_id,
      },
      props.redirect || null,
      true,
      props.location
    );

  if (smsData) {
    return (
      <>
        <Form
          // key is required to avoid remounting issues when switching between sms and normal login
          key="ACCOUNT_LOGIN_FORM_SMS"
          onSubmit={postSmsAction}
          render={({ handleSubmit, submitting }) => (
            <form
              onSubmit={handleSubmit}
              className="text-sm"
              data-test="ACCOUNT_LOGIN_FORM_SMS"
            >
              <div className="mb-4">
                <Field
                  name="sent_code"
                  type="text"
                  label="Cod SMS"
                  component={InputText}
                  autoComplete="one-time-code"
                  inputClassName="max-w-fulli"
                  required
                  validate={composeFormValidators(isRequired())}
                />
              </div>

              <div className="mb-4">
                <Button
                  title="Verifica"
                  display="block"
                  variant="primary"
                  type="submit"
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        />

        <div className="text-center text-sm">
          <button
            className="text-red-brand hover:text-bleu-hover underline"
            onClick={() => {
              setSmsData(null);
            }}
          >
            Renunta
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <Form
        // key is required to avoid remounting issues when switching between sms and normal login
        key="ACCOUNT_LOGIN_FORM"
        onSubmit={loginAction}
        render={({ handleSubmit, submitting }) => (
          <form
            onSubmit={handleSubmit}
            className="text-sm"
            data-test="ACCOUNT_LOGIN_FORM"
          >
            <div className="mb-4">
              <Field
                name="email"
                type="email"
                label="Introdu adresa de email"
                autoComplete="username"
                component={InputText}
                inputClassName="max-w-fulli"
                required
                placeholder="Introdu adresa de email"
                validate={composeFormValidators(
                  isRequired(),
                  isEmail(),
                  hasMaxLength(80)
                )}
              />
            </div>

            <div className="mb-6">
              <Field
                name="password"
                label="Parola"
                type="password"
                autoComplete="current-password"
                component={InputText}
                inputClassName="max-w-fulli"
                required
                placeholder="Introdu parola"
                validate={isRequired()}
              />
            </div>

            <div className="mb-4">
              <Button
                title="Logheaza-te in cont"
                display="block"
                variant="primary"
                type="submit"
                disabled={submitting}
              />
            </div>
          </form>
        )}
      />
      <div className="text-center text-sm">
        {props.recoverPassInModal ? (
          <button
            className="text-red-brand hover:text-bleu-hover underline"
            onClick={() => {
              props.removeModal();
              props.addModal(props.resetPassModalId);
            }}
          >
            Recuperare parola
          </button>
        ) : (
          <Link href={`${settings.baseUrl}/cont/parola-uitata/`}>
            <a className="text-red-brand hover:text-bleu-hover underline">
              Ai uitat parola?
            </a>
          </Link>
        )}
      </div>
    </>
  );
};

export default connect(null, {
  userLogin,
  addModal,
  removeModal,
})(LoginForm);
